<template>
    <div>
        <div  v-if="screen_width >= 768" class='logout' @click='logout'>Logout</div>
        <div class='logout-icon' v-if="screen_width < 768"  @click='logout'><i class="fa-solid fa-right-from-bracket"></i></div>

    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";

export default {
    props: ['logoutListener', 'screen_width'],
    methods:{
        async logout(){
            let response = await fetch(`/api/user/logout`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({}),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.$emit('logoutListener');
                 //this.$router.push('/');
                window.location.href = '/';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.logout{
    cursor: pointer;
    font-size: 0.93rem;
}

.logout-icon{
    cursor: pointer;
    font-size: 1.2rem;
}
</style>